export default __webpack_public_path__ + "static/media/email-icon-default-state.0a81569e.svg";